import React, { useEffect, useState } from 'react';
import { FaDownload, FaTrash } from 'react-icons/fa';
import ReactLoading from 'react-loading';
import './SavedReportTable.css';
import { getAnalyticalReportData, deleteAnalyticalReportDataDetails } from '../../services/api/fetchAnalyticalReportData';
import Pagination from '../Pagination/Pagination';
import { useParams } from 'react-router-dom';

function SavedReportTable() {
    const { clientId } = useParams();
    const [data, setData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (!clientId) return;

        const fetchData = async () => {
            setIsLoading(true);
            try {
                const response = await getAnalyticalReportData(clientId, currentPage, pageSize);
                setData(response);
                const total = Math.ceil(response.count / pageSize);
                setTotalPages(total);
            } catch (error) {
                console.error("Erro ao buscar dados:", error);
                setErrorMessage("Erro ao carregar relatórios.");
                setTimeout(() => setErrorMessage(''), 5000);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [clientId, currentPage]);

    const handleDownload = async (url, filename) => {
        if (!url) {
            setErrorMessage("Arquivo PDF não disponível.");
            setTimeout(() => setErrorMessage(''), 5000);
            return;
        }

        setIsLoading(true);
        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error("Erro na resposta do servidor.");
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = `${filename || 'relatorio'}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);

            setSuccessMessage("Relatório baixado com sucesso!");
            setTimeout(() => setSuccessMessage(''), 5000);
        } catch (error) {
            console.error("Erro ao baixar o arquivo:", error);
            setErrorMessage("Não foi possível baixar o PDF.");
            setTimeout(() => setErrorMessage(''), 5000);
        } finally {
            setIsLoading(false);
        }
    };

    const handleDelete = async (id) => {
        setIsLoading(true);
        try {
            await deleteAnalyticalReportDataDetails(id);
            setSuccessMessage("Relatório deletado com sucesso!");
            setData((prevData) => ({
                ...prevData,
                results: prevData.results.filter((item) => item.id !== id),
            }));
            setTimeout(() => setSuccessMessage(''), 5000);
        } catch (error) {
            console.error("Erro ao deletar:", error);
            setErrorMessage("Erro ao deletar relatório.");
            setTimeout(() => setErrorMessage(''), 5000);
        } finally {
            setIsLoading(false);
        }
    };

    const filteredResults = data?.results?.filter((item) => item.pdf_file);

    return (
      <>
        {successMessage && <div className="success-message">{successMessage}</div>}
        {isLoading && (
            <div className="loading-overlay active">
                <ReactLoading type={'spin'} color={'#121926'} height={80} width={80} />
            </div>
        )}
        {errorMessage && <div className="error-message">{errorMessage}</div>}
        <div className="table-container-saved-reports">
            <table className="table-relatorios-saved-reports">
                <thead>
                    <tr>
                        <th>Nome</th>
                        <th>Data Inicial</th>
                        <th>Data Final</th>
                        <th>Data Criação</th>
                        <th style={{ textAlign: 'center' }}>Ações</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredResults?.length > 0 ? (
                        filteredResults.map((item) => (
                            <tr key={item.id}>
                                <td>{item.name || '-'}</td>
                                <td>{item.date_start}</td>
                                <td>{item.date_end}</td>
                                <td>{item.created}</td>
                                <td style={{ textAlign: 'center' }}>
                                    <button
                                        onClick={() => handleDownload(item.pdf_file, item.name)}
                                        className="btn-download-saved-reports"
                                    >
                                        <FaDownload className="icon-saved-reports" />
                                        <span className='tooltip-text-saved-reports'>Download</span>
                                    </button>
                                    <button
                                        onClick={() => handleDelete(item.id)}
                                        className="btn-delete-saved-reports"
                                    >
                                        <FaTrash className="icon-saved-reports" />
                                        <span className='tooltip-text-saved-reports'>Excluir</span>
                                    </button>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="5" style={{ textAlign: 'center', padding: '16px' }}>
                                Nenhum relatório com PDF disponível.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
        <div>
          {totalPages > 1 && (
              <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={setCurrentPage}
              />
          )}
        </div>
        </>
    );
}

export default SavedReportTable;
